var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "42px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "42px",
    height: "42px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAQAAABvygHQAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoAhUUGCH+mUQpAAACOklEQVRIx7VXyZWjMBD95s0dMqAysDJoZYAycGcAHQkdQmeAHYFxBDARoAwgg5qDWLu1MW9GdWBR6evXopJ0YUQ02r3rsPovP1QvHkUvNPWZ+SUm0qIvHqL3wrNdaJBVQ+zs5qoZJDsUrCNG8f4Eh+X9OQobsAWyqbIIQCMZN9VP2B+QcRyPfL/DHj5GobqzkGCw6kbhAiU7ZM513Skmpk7Vde6A3bMNGl7XTLsBxFTXNr2y2bR24bGpdsoSXeqUTXcL2erNzMVyZbhjbGWb8eLZWelmMT3nGYQGqTpiYtWtCU82397mPACDMUh4eA4y27EZpJsr5l4wmMrG4U8wmIpDThRznO1+NeECg4nYprD48ehtWp1iG2N6nXO6xQdq7EuAexFTUpdW9ObZC3t/+waAcfSZX9I1UPY4gIuOASYxxkMui2GfEUcRI5PTNz7IUfiInAKNgzwFuiyFEOQJ0G3JhisuUwJcp3AiVZ/meVd34de8TkACTRE7uXxBA6BwTpOGTgDRh0EXnZcMTt8CCaAeYVAABIo5nsgXTEHJI0IVJyagCQCoexTXiDYjmUX3r5huRdqxnZyXZUedv0eRBhLaiE8nXTe+xPgim74+Au7SodB/fWTT/LpO5HWBv9rvTd+Zb4a4y3XI/NvTfuwBYxRndoFNCs8B7S/zYG+4HRRMTZVGA6ZRh14wmEYRx7dsYo/nM/Agy8ZdE3IuPReJi+ceRUAv2rdWavqdmV/XibRs5ct/5bn8j8vZHwPYZefRe21bAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.d719f3584240c4722166463b895e02b5.svg";
export { ForwardRef as ReactComponent };